const $ = jQuery;
let InputNumber = {
  var: {
    min: 0,
    max: null,
    step: 1,
  },
  dom: { inputs: $('input[type="number"]') },
  increase: ($input) => {
    const currentVal = parseFloat($input.val());
    const newValue = currentVal + InputNumber.var.step;

    if (
      (InputNumber.var.max != null && newValue <= InputNumber.var.max) ||
      InputNumber.var.max == null
    ) {
      $input.val(newValue);
      $input.trigger("change");
    }
  },
  decrease: ($input) => {
    const currentVal = parseFloat($input.val());
    const newValue = currentVal - InputNumber.var.step;

    if (InputNumber.var.min <= newValue) {
      $input.val(newValue);
      $input.trigger("change");
    }
  },
  makeDom: () => {
    for (let index = 0; index < $('input[type="number"]').length; index++) {
      const $inputWrapper = $('<div class="input-wrapper" />');
      const $this = $($('input[type="number"]')[index]);
      const $quanitity = $('<span class="quantity-text>Kolicina: </span>');
      const $plus =
        $(`<svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.12 7.624H3.904V4.584H0.72V3.464H3.904V0.424H5.12V3.464H8.304V4.584H5.12V7.624Z" fill="#0C331F"/>
</svg>
`);
      const $minus =
        $(`<svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.568 1.584H0.72V0.464H7.568V1.584Z" fill="#0C331F"/>
</svg>
`);

      if ($this.attr("min") && $this.attr("min") != "")
        InputNumber.var.min = parseFloat($this.attr("min"));
      if ($this.attr("max") && $this.attr("max") != "")
        InputNumber.var.max = parseFloat($this.attr("max"));
      if ($this.attr("step") && $this.attr("step") != "")
        InputNumber.var.step = parseFloat($this.attr("step"));

      $this.wrapAll($inputWrapper);

      const $parent = $this.parent();

      $parent.append($plus);
      $parent.append($minus);

      $plus.on("click", () => {
        InputNumber.increase($this);
      });
      $minus.on("click", () => {
        InputNumber.decrease($this);
      });
    }
  },
  init: function () {
    InputNumber.makeDom();
    $("body").on("updated_wc_div", function () {
      console.log("SSS");

      InputNumber.makeDom();
    });
  },
};
export default InputNumber;
